module.exports = __webpack_public_path__ + "static/media/techlead.f2b994d4.jpg";